import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { ChevronDown } from "lucide-react";
import FlexBox from "components/common/FlexBox";

export const FAQ: React.FC<{
  question: string;
  answer: string | React.ReactNode;
}> = ({ question, answer }) => {
  const isMobile = useIsMobile();
  return (
    <FlexBox gap={isMobile ? "24px" : "48px"}>
      <Accordion variant="borderless">
        <AccordionSummary expandIcon={<ChevronDown />}>
          <Typography variant="bodyHeavy">{question}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="bodySmall">{answer}</Typography>
        </AccordionDetails>
      </Accordion>
    </FlexBox>
  );
};
